export const GET_DOCUMENTS = 'GET_DOCUMENTS'
export const GET_DOCUMENT = 'GET_DOCUMENT'
export const DELETE_DOCUMENT = 'DELETE_DOCUMENT'
export const GET_DOC_SIGNED_URL = 'GET_DOC_SIGNED_URL'
export const CONFIRM_DOC_UPLOAD = 'CONFIRM_DOC_UPLOAD'
